import { Dropdown } from "primereact/dropdown";
import React, { FunctionComponentElement } from "react";
import { NodeInputProps } from "./index";
import { ITopology, useGetTopologiesQuery } from "../../app/apiSlice";
import "./Form.module.scss";
import { classNames } from 'primereact/utils';
import {  useAppSelector } from "../../hooks/hooks";

export const PipelineChoiceInput = (props: NodeInputProps): FunctionComponentElement<NodeInputProps> => {

    const environment = useAppSelector((state) => state.editor.current?.environnement)
    const topology = useAppSelector((state) => state.editor.current)
    const {data, ...status} = useGetTopologiesQuery({
        field:"",
        search:"",
        page:0,
        perPage:1000,
        sort:"",
        env:environment ? environment : "BAS,EID,PROD",
    });
    var combinedList: ITopology[] | undefined = data?.topologies || [];
    return <>
        <Dropdown
            className={classNames({'p-invalid': status.isError})}
            disabled={status.isError || props.disabled}
            filter
            emptyFilterMessage="Aucune topologie correspondante"
            value={combinedList?.find((element) => (element.id === props.value || element.id === props.value?.id))}
            options={combinedList?.filter(t => t.runtimeMode === "basic").sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))}
            optionLabel="name"
            onChange={(element) => {
                props.onChange(element.value)
            }}
            placeholder={props.placeholder}
        />
        {status.isError && <span style={{color: 'red'}}>Erreur lors de la recherche des topologies </span>}
    </>
}